import { type CommonTranslationFunction } from '@autone/translations';
import { type ParseError } from 'papaparse';

export const getParsingError = (
  common: CommonTranslationFunction,
  errors: ParseError[],
): string => {
  switch (errors[0]?.code) {
    case 'InvalidQuotes':
      return common('error-messages.csv-upload.invalid-qoutes');
    case 'MissingQuotes':
      return common('error-messages.csv-upload.missing-quotes');
    case 'TooFewFields':
      return common('error-messages.csv-upload.too-few-fields');
    case 'TooManyFields':
      return common('error-messages.csv-upload.too-many-fields');
    case 'UndetectableDelimiter':
      return common('error-messages.csv-upload.undetectable-delimit');
    default:
      return common('error-messages.csv-upload.default');
  }
};
